import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormsService} from "../../../shared/forms.service";

@Component({
  selector: 'app-mail-details',
  templateUrl: './mail-details.component.html',
  styleUrls: ['./mail-details.component.scss']
})

export class MailDetailsComponent implements OnInit {

  @Output() send = new EventEmitter();

  detailsForm: FormGroup;

  editorOptions = {
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['clean'],
      ]
    },
  };

  constructor(private fb: FormBuilder, private formsService: FormsService){
    this.createFormGroup();
  }

  ngOnInit() {

  }

  onSend() {
    this.send.emit();
  }

  private createFormGroup () {
    this.detailsForm = this.fb.group({
      'textMail': [
        null
      ],
      'subject': [
        null
      ],

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/book/book-send/second-step/mail-details.component.ts